var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products.length > 0
    ? _c(
        "section",
        {
          class: _vm.bemBlockMod({ "wrap-items": _vm.wrapItems }),
          attrs: {
            "data-context": _vm.tileContext,
            "data-location": _vm.locationForAnalytics
          }
        },
        [
          _vm.heading
            ? _c("p", { class: _vm.bemElement("heading") }, [
                _vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "swiper",
              class: [_vm.bemElement("slider"), "swiper", "u-scrollbar-none"],
              attrs: { itemtype: "http://schema.org/SomeProducts" }
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.products, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: "product-slider-" + index,
                      staticClass: "swiper-slide",
                      class: _vm.bemElement("item")
                    },
                    [
                      _c("BaseProductTile", {
                        attrs: {
                          analytics: _vm.buildAnalyticsPropForProduct(index),
                          context: _vm.tileContext,
                          keyid: item.product.id + "-" + index,
                          "grid-index": index,
                          "has-carousel": _vm.isBreakpointDesktop,
                          "hide-product-names": _vm.hideProductNames,
                          "hide-prices": _vm.hidePrices,
                          "hide-discount": _vm.hideDiscount,
                          "hide-quick-shop": _vm.hideQuickShop,
                          "hide-tags": _vm.hideTileTags,
                          "show-swatches": false,
                          product: item.product,
                          url: item.urls.product,
                          "is-recommendation-from-einstein":
                            _vm.isRecommendationFromEinstein,
                          "recommender-name": _vm.recommenderName
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.showScrollbar
                ? _c("div", { class: _vm.bemElement("scrollbar") }, [
                    _c("div", {
                      ref: "scrollbarProgress",
                      class: _vm.bemElement("scrollbar-progress")
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.navigation
                ? [
                    _c("div", {
                      class: [
                        _vm.bemElement("scroll-hover"),
                        ((_obj = {}),
                        (_obj[_vm.bemElement("scroll-hover--click")] =
                          _vm.navigation === "click"),
                        _obj),
                        "the-home-custom-slider__scroll-hover",
                        "the-home-custom-slider__scroll-hover--left",
                        {
                          "the-home-custom-slider__scroll-hover--hidden":
                            _vm.isBeginning
                        }
                      ],
                      on: {
                        mouseenter: function($event) {
                          return _vm.onNavigationEnter(-1)
                        },
                        mouseleave: _vm.stopHoverScroll,
                        click: function($event) {
                          return _vm.onNavigationClick(-1)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      class: [
                        _vm.bemElement("scroll-hover"),
                        ((_obj$1 = {}),
                        (_obj$1[_vm.bemElement("scroll-hover--click")] =
                          _vm.navigation === "click"),
                        _obj$1),
                        "the-home-custom-slider__scroll-hover",
                        "the-home-custom-slider__scroll-hover--right",
                        {
                          "the-home-custom-slider__scroll-hover--hidden":
                            _vm.isEnd
                        }
                      ],
                      on: {
                        mouseenter: function($event) {
                          return _vm.onNavigationEnter(1)
                        },
                        mouseleave: _vm.stopHoverScroll,
                        click: function($event) {
                          return _vm.onNavigationClick(1)
                        }
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }